import { render, staticRenderFns } from "./SoftTermBDE.vue?vue&type=template&id=0eaf31ac&scoped=true"
import script from "./SoftTermBDE.vue?vue&type=script&lang=ts"
export * from "./SoftTermBDE.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaf31ac",
  null
  
)

export default component.exports